// @flow
import React from 'react';
import { getCurrentMLDRowDimensionValues } from '@components/custom-discounts/utils';
import { areAllValuesInGivenArrayNonNullOrNonEmptyArray } from '@src/common-utils/utils';
import { TinyHeaderSpan } from '@presentational/headings/TinyHeaderSpan';

import { StyledDropdownWithAccessibility } from '../../../../common-utils/styledComponents';
import {
  getMultiSelectUsageDropdownDisplayText,
  getMultiSelectUsageOptions,
  getUsageCalculatorFuncForMetric,
} from '../../mld-for-field/utils';

export const MultiSelectUsageDropdown = ({ metricName, mldGuidance, rowValues }) => {
  const currentRowDimValuesArray = getCurrentMLDRowDimensionValues(rowValues);

  if (!areAllValuesInGivenArrayNonNullOrNonEmptyArray(currentRowDimValuesArray)) {
    return <TinyHeaderSpan headerText="Please fill all dims!" />;
  }

  const usageCalculatorFunc = getUsageCalculatorFuncForMetric(metricName);
  const explodedUsagesObject = usageCalculatorFunc(
    mldGuidance,
    currentRowDimValuesArray,
    metricName
  );

  const dropdownOptions = getMultiSelectUsageOptions(explodedUsagesObject);
  const displayText = getMultiSelectUsageDropdownDisplayText(dropdownOptions);

  return (
    <StyledDropdownWithAccessibility
      disabled={false}
      fluid={true}
      options={dropdownOptions}
      placeholder="Usage"
      selection={true}
      text={displayText}
      value={null}
    />
  );
};
